import {Component, Inject} from '@angular/core';
import {CategoryEntryComponent} from '../category-entry/category-entry.component';
import {DOCUMENT} from '@angular/common';
import {CategoryService} from '@app/services/category.service';

@Component({
  selector: 'dcp-category-sub-entries',
  templateUrl: './category-sub-entries.component.html',
  styleUrls: ['./category-sub-entries.component.scss']
})
export class CategorySubEntriesComponent extends CategoryEntryComponent {

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public categoryService: CategoryService
  ) {
    super(document, categoryService);
  }
}

